<template>
  <div>
    <Form :model="setting" :rules="rules" :label-width="200">
      <FormItem :label="$t('pages_settings_index_948')">
        <el-select
          v-model="setting.timezone"
          :multiple="false"
          size="small"
          :placeholder="$t('pages_orders_show_674')"
          style="width: 500px"
          @change="change_timezone"
        >
          <el-option
            v-for="item in country_timezones"
            :key="item.code"
            :label="item.name"
            :value="item.code"
          >
          </el-option>
        </el-select>
      </FormItem>
      <FormItem :label="$t('pages_settings_index_949')">
        <el-select
          v-model="setting.currency"
          :multiple="false"
          size="small"
          :placeholder="$t('pages_orders_show_674')"
          style="width: 500px"
          @change="change_currency"
        >
          <el-option
            v-for="item in country_currencies"
            :key="item.currency_code"
            :label="item.currency_code + ' ' + item.name"
            :value="item.currency_code"
          >
          </el-option>
        </el-select>
      </FormItem>
      <FormItem :label="$t('pages_settings_index_950')">
        <el-select
          v-model="setting.receipt_language"
          :multiple="false"
          size="small"
          :placeholder="$t('pages_orders_show_674')"
          style="width: 500px"
          @change="change_receipt_language"
        >
          <el-option
            v-for="item in receiptLanguage"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </FormItem>
      <FormItem :label="$t('pages_settings_index_951')">
        <i-switch
          v-model="setting.ticket_qr_show"
          size="large"
          @on-change="change"
        >
          <span slot="open">{{ $t("pages_settings_index_952") }}</span>
          <span slot="close">{{ $t("pages_settings_index_953") }}</span>
        </i-switch>
      </FormItem>
      <!-- <br /> -->
      <FormItem :label="$t('pages_settings_index_954')">
        <i-switch
          v-model="setting.pickup_code_show"
          size="large"
          @on-change="change_pickup_code_show"
        >
          <span slot="open">{{ $t("pages_settings_index_952") }}</span>
          <span slot="close">{{ $t("pages_settings_index_953") }}</span>
        </i-switch>
      </FormItem>
      <!-- <br /> -->
      <FormItem :label="$t('pages_settings_index_955')">
        <Input
          style="width: 500px"
          type="text"
          v-model="setting.pickup_code_alias_name"
          @on-blur="change_pickup_code_alias_name"
        />
      </FormItem>
      <!-- <br /> -->
      <FormItem :label="$t('pages_settings_index_956')">
        <i-switch
          v-model="setting.pickup_code_auto_clear"
          size="large"
          @on-change="change_pickup_code_auto_clear"
        >
          <span slot="open">{{ $t("libs_table_render_50") }}</span>
          <span slot="close">{{ $t("directives_index_41") }}</span>
        </i-switch>
      </FormItem>
      <Form-item
        :label="$t('pages_settings_index_957')"
        style="max-width: 700px"
        prop="order_pickup_code_digit"
      >
        <i-input
          v-model="setting.order_pickup_code_digit"
          @on-blur="change_order_pickup_code_digit"
          :placeholder="$t('pages_settings_index_957')"
        >
        </i-input>
      </Form-item>
      <FormItem :label="$t('pages_settings_index_958')">
        <i-switch
          v-model="setting.vip_sms_open"
          size="large"
          @on-change="change_sms_open"
        >
          <span slot="open">{{ $t("pages_customer_level_index_294") }}</span>
          <span slot="close">{{
            $t("pages_birthday_discount_index_209")
          }}</span>
        </i-switch>
      </FormItem>
      <!-- <br /> -->
      <FormItem :label="$t('pages_settings_index_959')">
        <i-switch
          v-model="setting.zero_stock_sale"
          size="large"
          @on-change="change_zero_stock_sale"
        >
          <span slot="open">{{ $t("pages_customer_level_index_294") }}</span>
          <span slot="close">{{
            $t("pages_birthday_discount_index_209")
          }}</span>
        </i-switch>
      </FormItem>
      <!-- <br /> -->
      <FormItem :label="$t('pages_customer_level_index_293')">
        <i-switch
          v-model="setting.customer_level_auto_upgrade"
          size="large"
          @on-change="change_customer_level_auto_upgrade"
        >
          <span slot="open">{{ $t("pages_customer_level_index_294") }}</span>
          <span slot="close">{{
            $t("pages_birthday_discount_index_209")
          }}</span>
        </i-switch>
      </FormItem>
       
      <FormItem :label="$t('pages_settings_index_960')">
        <el-select
          v-model="setting.customer_level_upgrade_method"
          :multiple="false"
          size="small"
          :placeholder="$t('pages_orders_show_674')"
          style="width: 500px"
          @change="change_customer_level_upgrade_method"
        >
          <el-option
            v-for="item in upgradeMethod"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </FormItem>
      <FormItem :label="$t('pages_settings_index_961')">
        <i-switch
          v-model="setting.customer_score_open"
          size="large"
          @on-change="change_customer_score_open"
        >
          <span slot="open">{{ $t("pages_customer_level_index_294") }}</span>
          <span slot="close">{{
            $t("pages_birthday_discount_index_209")
          }}</span>
        </i-switch>
      </FormItem>
      <Form-item
        :label="$t('pages_settings_index_962')"
        style="max-width: 700px"
        prop="score_alias_name"
      >
        <i-input
          v-model="setting.score_alias_name"
          @on-blur="change_score_alias_name"
          :placeholder="$t('pages_settings_index_962')"
        >
        </i-input>
      </Form-item>
      <FormItem prop="score_gain_rate" :label="$t('pages_settings_index_963')">
        <i-input
          type="number"
          style="width: 500px"
          v-model="setting.score_gain_rate"
          @on-blur="change_score_gain_rate"
          @input="soreChange"
          :placeholder="$t('pages_settings_index_964')"
        />
        <Tooltip :content="$t('pages_settings_index_965')" placement="top">
          <Icon
            type="ios-help-circle"
            color="#259ade"
            style="font-size: 20px; margin-left: 12px"
          />
        </Tooltip>
      </FormItem>
      <!-- <br /> -->
      <Form-item :label="$t('pages_settings_index_966')" prop="discount_order">
        <DraggableList
          v-model="setting.discount_order"
          :get-row-key="getDiscountRowOrder"
          :render-item="renderDiscountItem"
          @on-change="change_discount_order"
        />
        <!-- <Input type="text" v-model="setting.discount_order" /> -->
      </Form-item>
      <Form-item
        :label="$t('pages_settings_index_967')"
        prop="second_card_rate"
      >
        <Input
          style="width: 500px"
          :disabled="setting.is_chain_store"
          type="number"
          v-model="setting.second_card_rate"
          @on-blur="saveSecondCardRate"
        />
        <Tooltip
          v-if="setting.is_chain_store"
          :content="$t('pages_settings_index_968')"
        >
          <Icon
            type="ios-help-circle"
            color="#259ade"
            style="font-size: 20px; margin-left: 12px"
          />
        </Tooltip>
      </Form-item>
      <Form-item
        :label="$t('pages_settings_index_969')"
        style="max-width: 700px"
        prop="package_id"
      >
        <i-select @on-change="savePackageId" v-model="setting.package_id">
          <i-option v-for="pkg in packages" :key="pkg.id" :value="pkg.id">{{
            pkg.title
          }}</i-option>
        </i-select>
        <div v-if="selectedPkg.id">
          <div>规格：{{ selectedPkg.spec || "未设置规格" }}</div>
          <p>{{ $t("pages_settings_index_971") }}</p>
          <a v-if="selectedPkg.picture" :href="selectedPkg.picture">
            <img :src="selectedPkg.picture" width="220px" />
          </a>
          <div
            v-else
            style="
              background: #ddd;
              height: 100px;
              text-align: center;
              line-height: 100px;
              color: #999;
            "
          >
            <h2>{{ $t("pages_settings_index_972") }}</h2>
          </div>
        </div>
      </Form-item>
      <Form-item
        :label="$t('pages_settings_index_973')"
        style="max-width: 700px"
        prop="warm_tips"
      >
        <i-input
          v-model="setting.warm_tips"
          @on-blur="saveWarmTips"
          :placeholder="$t('pages_settings_index_974')"
        >
        </i-input>
      </Form-item>
      <Form-item
        :label="$t('pages_settings_index_975')"
        style="max-width: 700px"
        prop="bar_code_id"
      >
        <i-select @on-change="saveBarcodeId" v-model="setting.bar_code_id">
          <i-option
            v-for="barcode in bar_codes"
            :key="barcode.id"
            :value="barcode.id"
            >{{ barcode.content }}</i-option
          >
        </i-select>
      </Form-item>
      <Form-item
        :label="$t('pages_settings_index_976')"
        style="max-width: 700px"
        prop="shop_code"
      >
        <i-input
          v-model="setting.shop_code"
          @on-blur="saveShopCode"
          :placeholder="$t('pages_settings_index_976')"
        >
        </i-input>
      </Form-item>
      <Form-item
        :label="$t('pages_settings_index_977')"
        style="max-width: 700px"
        prop="alipay_merchant_no"
      >
        <i-input
          v-model="setting.alipay_merchant_no"
          @on-blur="saveAlipayMerchantNo"
          :placeholder="$t('pages_settings_index_977')"
        >
        </i-input>
      </Form-item>
      <Form-item
        :label="$t('pages_settings_index_978')"
        style="max-width: 700px"
        prop="second_card_name"
      >
        <i-input
          v-model="setting.second_card_name"
          @on-blur="saveSecondCardName"
          :placeholder="$t('pages_settings_index_978')"
        >
        </i-input>
      </Form-item>
      <Form-item
        :label="$t('pages_settings_index_979')"
        style="max-width: 700px"
        prop="show_virtual_weight"
      >
        <i-switch
          v-model="setting.show_virtual_weight"
          size="large"
          @on-change="saveVirtualWeight"
        >
          <span slot="open">{{ $t("pages_customer_level_index_294") }}</span>
          <span slot="close">{{
            $t("pages_birthday_discount_index_209")
          }}</span>
        </i-switch>
        <Tooltip v-if="setting.is_chain_store" placement="top" width="500">
          <div slot="content" style="width: 500px">
            <p>{{ $t("pages_settings_index_980") }}</p>
            <p>{{ $t("pages_settings_index_981") }}</p>
          </div>
          <Icon
            type="ios-help-circle"
            color="#259ade"
            style="font-size: 20px; margin-left: 12px"
          />
        </Tooltip>
      </Form-item>
      <FormItem :label="$t('pages_settings_index_982')">
        <i-switch
          v-model="setting.open_wechat_facepay"
          size="large"
          @on-change="change_open_wechat_facepay"
        >
          <span slot="open">{{ $t("pages_birthday_discount_index_208") }}</span>
          <span slot="close">{{
            $t("pages_birthday_discount_index_209")
          }}</span>
        </i-switch>
      </FormItem>
      <FormItem :label="$t('pages_settings_index_983')">
        <i-switch
          v-model="setting.open_alipay_facepay"
          size="large"
          @on-change="change_open_alipay_facepay"
        >
          <span slot="open">{{ $t("pages_birthday_discount_index_208") }}</span>
          <span slot="close">{{
            $t("pages_birthday_discount_index_209")
          }}</span>
        </i-switch>
      </FormItem>
      <FormItem :label="$t('pages_settings_index_984')">
        <i-switch
          v-model="setting.show_mp"
          size="large"
          @on-change="change_show_mp"
        >
          <span slot="open">{{ $t("pages_settings_index_952") }}</span>
          <span slot="close">{{ $t("pages_settings_index_953") }}</span>
        </i-switch>
      </FormItem>
      <FormItem
        :label="$t('pages_first_order_discount_index_501')"
        style="max-width: 700px"
      >
        <i-input
          v-model="setting.first_order_discount"
          @on-blur="change_first_order_discount"
          :placeholder="$t('pages_first_order_discount_index_501')"
        />
      </FormItem>
      <FormItem :label="$t('pages_first_order_discount_index_502')">
        <i-switch
          v-model="setting.first_order_discount_open"
          size="large"
          @on-change="change_first_order_discount_open"
        >
          <span slot="open">{{ $t("pages_birthday_discount_index_208") }}</span>
          <span slot="close">{{
            $t("pages_birthday_discount_index_209")
          }}</span>
        </i-switch>
      </FormItem>
      <Form-item
        :label="$t('pages_materials_index_614')"
        style="max-width: 700px"
        prop="material_alias_name"
      >
        <i-input
          v-model="setting.material_alias_name"
          @on-blur="change_material_alias_name"
          :placeholder="$t('pages_materials_index_614')"
        >
        </i-input>
      </Form-item>
      <FormItem :label="$t('pages_settings_index_985')">
        <TimeRangeGroup
          start-key="wechat_operate_start_at"
          end-key="wechat_operate_end_at"
          v-model="setting.wechat_operate_duration"
          @input="changeDuration"
        />
      </FormItem>
      <FormItem :label="$t('pages_settings_index_986')">
        <i-switch
          v-model="setting.auto_receive"
          size="large"
          @on-change="change_auto_receive"
        >
          <span slot="open">{{ $t("libs_table_render_50") }}</span>
          <span slot="close">{{ $t("directives_index_41") }}</span>
        </i-switch>
      </FormItem>
      <FormItem
        :label="$t('pages_settings_index_987')"
        style="max-width: 700px"
      >
        <i-input
          v-model="setting.receive_duration_day"
          @on-blur="change_receive_duration_day"
          :placeholder="$t('pages_settings_index_988')"
        >
          <span slot="append">{{ $t("pages_settings_index_989") }}</span>
        </i-input>
      </FormItem>
      <FormItem :label="$t('pages_settings_index_990')">
        <i-switch
          v-model="setting.login_window_alert"
          size="large"
          @on-change="change_login_window_alert"
        >
          <span slot="open">{{ $t("pages_customer_level_index_294") }}</span>
          <span slot="close">{{
            $t("pages_birthday_discount_index_209")
          }}</span>
        </i-switch>
      </FormItem>
      <FormItem :label="$t('pages_settings_index_991')">
        <i-switch
          v-model="setting.auto_close_estimation"
          size="large"
          @on-change="change_auto_close_estimation"
        >
          <span slot="open">{{ $t("pages_customer_level_index_294") }}</span>
          <span slot="close">{{
            $t("pages_birthday_discount_index_209")
          }}</span>
        </i-switch>
      </FormItem>
      <FormItem :label="$t('pages_settings_index_992')">
        <i-switch
          v-model="setting.is_frontent_attend_rebate"
          size="large"
          @on-change="change_is_frontent_attend_rebate"
        >
          <span slot="open">{{ $t("libs_table_render_50") }}</span>
          <span slot="close">{{ $t("directives_index_41") }}</span>
        </i-switch>
      </FormItem>
      <FormItem
        :label="$t('pages_settings_index_993')"
        style="max-width: 700px"
      >
        <i-input
          v-model="setting.tax_rate"
          type="text"
          @on-blur="change_tax_rate"
          :placeholder="$t('pages_settings_index_994')"
        >
          <span slot="append">%</span>
        </i-input>
      </FormItem>
      <FormItem
        :label="$t('pages_settings_index_995')"
        style="max-width: 700px"
      >
        <i-input
          v-model="setting.service_charge_rate"
          type="text"
          @on-blur="change_service_charge_rate"
          :placeholder="$t('pages_settings_index_996')"
        >
          <span slot="append">%</span>
        </i-input>
      </FormItem>
      <FormItem
        :label="$t('pages_settings_index_997')"
        style="max-width: 700px"
      >
        <i-input
          v-model="setting.receipt_pay_channel"
          type="text"
          @on-blur="change_receipt_pay_channel"
          :placeholder="$t('pages_settings_index_997')"
        >
        </i-input>
      </FormItem>
      <FormItem
        :label="$t('pages_settings_index_998')"
        style="max-width: 700px"
      >
        <i-input
          v-model="setting.receipt_pay_username"
          type="text"
          @on-blur="change_receipt_pay_username"
          :placeholder="$t('pages_settings_index_998')"
        >
        </i-input>
      </FormItem>
      <FormItem
        :label="$t('pages_settings_index_999')"
        style="max-width: 700px"
      >
        <i-input
          v-model="setting.receipt_pay_qr_content"
          type="text"
          @on-blur="change_receipt_pay_qr_content"
          :placeholder="$t('pages_settings_index_999')"
        >
        </i-input>
      </FormItem>
      <FormItem
        :label="$t('pages_settings_index_1000')"
        style="max-width: 700px"
      >
        <i-input
          v-model="setting.welcome_content"
          type="text"
          @on-blur="change_receipt_welcome_content"
          :placeholder="$t('pages_settings_index_1000')"
        >
        </i-input>
      </FormItem>
      <FormItem :label="$t('pages_settings_index_1001')">
        <i-switch
          v-model="setting.open_score_shop"
          size="large"
          @on-change="change_open_score_shop"
        >
          <span slot="open">{{ $t("pages_settings_index_952") }}</span>
          <span slot="close">{{ $t("pages_settings_index_953") }}</span>
        </i-switch>
      </FormItem>
      <FormItem
        prop="customer_score_rate"
        :label="$t('pages_settings_index_1002')"
      >
        <i-input
          type="number"
          style="width: 500px"
          v-model="setting.customer_score_rate"
          @on-blur="change_customer_score_rate"
          :placeholder="$t('pages_settings_index_1003')"
        />
        <Tooltip :content="$t('pages_settings_index_1004')" placement="top">
          <Icon
            type="ios-help-circle"
            color="#259ade"
            style="font-size: 20px; margin-left: 12px"
          />
        </Tooltip>
      </FormItem>
      <FormItem :label="$t('pages_settings_index_1005')">
        <i-switch
          v-model="setting.pay_method_button_display"
          size="large"
          @on-change="change_pay_method_button_display"
        >
          <span slot="open">{{ $t("pages_settings_index_952") }}</span>
          <span slot="close">{{ $t("pages_settings_index_953") }}</span>
        </i-switch>
      </FormItem>
      <FormItem :label="$t('pages_settings_index_1006')">
        <i-switch
          v-model="setting.show_language_button"
          size="large"
          @on-change="change_show_language_button"
        >
          <span slot="open">{{ $t("pages_settings_index_952") }}</span>
          <span slot="close">{{ $t("pages_settings_index_953") }}</span>
        </i-switch>
      </FormItem>
      <FormItem :label="$t('setting_new_1342')">
        <i-switch
          v-model="setting.enable_tax"
          size="large"
          @on-change="change_enable_tax"
        >
          <span slot="open">{{ $t("pages_customer_level_index_294") }}</span>
          <span slot="close">{{
            $t("pages_birthday_discount_index_209")
          }}</span>
        </i-switch>
      </FormItem>
       <FormItem :label="$t('setting_new_1343')">
        <i-switch
          v-model="setting.enable_i18n"
          size="large"
          @on-change="change_enable_i18n"
        >
          <span slot="open">{{ $t("pages_customer_level_index_294") }}</span>
          <span slot="close">{{
            $t("pages_birthday_discount_index_209")
          }}</span>
        </i-switch>
      </FormItem>
    </Form>
  </div>
</template>

<script>
import i18n from "../../locales/index";

import { mapGetters, mapActions, mapState } from "vuex";
import DraggableList from "_c/form-items/drag-list";
import TimeRangeGroup from "./TimeRangeGroup";

export default {
  components: {
    DraggableList,
    TimeRangeGroup,
  },
  data() {
    return {
      rules: {
        customer_score_rate: [
          {
            validator: (rule, value, callback) => {
              if (!value) return callback();
              if (value < 0)
                return callback(
                  new Error(i18n.t("pages_birthday_discount_index_210"))
                );
              callback();
            },
          },
        ],
      },
      receiptLanguage: [
        {
          value: "zh-CN",
          // label: i18n.t("pages_settings_index_1007"),
          label: '中文简体',
        },
        {
          value: "zh-HK",
          // label: i18n.t("pages_settings_index_1008"),
          label: '中文繁體',
        },
        {
          value: "en",
          // label: i18n.t("pages_settings_index_1009"),
          label: 'English',
        },
        {
          value: "th",
          // label: i18n.t("pages_settings_index_1010"),
          label: 'ภาษาไทย',
        },
        {
          value: "es",
          // label: i18n.t("pages_settings_index_1013"),
          label: 'Español',
        },
        {
          value: "jp",
          label: '日本語',
        },
        {
          value: "fr",
          label: 'Français',
        },
        {
          value: "vi",
          label: 'Tiếng Việt',
        },
        {
          value: "kr",
          label: '한국어',
        },
        {
          value: "eu",
          label: 'Italiano',
        },
        {
          value: "de",
          label: 'Deutsch',
        }
      ],
      upgradeMethod: [
        {
          value: "consume",
          label: i18n.t("pages_settings_index_1011"),
        },
        {
          value: "storage",
          label: i18n.t("pages_settings_index_1012"),
        },
      ],
      // currencyList: [{
      //   value: '￥',
      //   label: '￥ 元'
      // }, {
      //   value: '$',
      //   label: '$ 美元'
      // }, {
      //   value: 'THB',
      //   label: 'THB 泰铢'
      // }],
      // timezoneList: [{
      //   value: 'Beijing',
      //   label: '北京'
      // }, {
      //   value: 'Bangkok',
      //   label: '曼谷'
      // }, {
      //   value: 'Bucharest',
      //   label: '布加勒斯特'
      // }]
    };
  },
  created() {
    this.display();
    this.fetchPackages({ page: 1, per: 65536 });
    this.fetchBarcodes({ page: 1, per: 65536 });
    this.getTimezones({ page: 1, per: 65536 });
    this.getCurrencies({ page: 1, per: 65536 });
  },
  computed: {
    ...mapGetters("setting", ["setting"]),
    ...mapState("package", ["packages"]),
    ...mapState("bar_code", ["bar_codes"]),
    ...mapGetters("country_timezone", ["country_timezones"]),
    ...mapGetters("country_currency", ["country_currencies"]),
    selectedPkg() {
      const id = this.setting.package_id;
      const pkg = this.packages.find((i) => i.id === id);
      return pkg || {};
    },
  },
  watch: {
    setting: {
      immediate: false,
      async handler(value) {
        // this.setting.receipt_language = (value.receipt_language || '').split(',')
      },
    },
  },
  methods: {
    ...mapActions("setting", ["display", "upgrade"]),
    ...mapActions("package", {
      fetchPackages: "index",
    }),
    ...mapActions("bar_code", {
      fetchBarcodes: "index",
    }),
    ...mapActions("country_timezone", { getTimezones: "index" }),
    ...mapActions("country_currency", { getCurrencies: "index" }),
    change() {
      this.upgrade({ ticket_qr_show: this.setting.ticket_qr_show });
    },
    soreChange(e) {
      console.log(e);
      if (e < 0) {
        this.setting.score_gain_rate = 0;
      }
    },
    change_receipt_pay_channel() {
      this.upgrade({ receipt_pay_channel: this.setting.receipt_pay_channel });
    },
    change_receipt_pay_username() {
      this.upgrade({ receipt_pay_username: this.setting.receipt_pay_username });
    },
    change_receipt_pay_qr_content() {
      this.upgrade({
        receipt_pay_qr_content: this.setting.receipt_pay_qr_content,
      });
    },
    change_receipt_welcome_content() {
      this.upgrade({ welcome_content: this.setting.welcome_content });
    },
    change_receipt_language() {
      // this.upgrade({ receipt_language: this.setting.receipt_language.join(',') })
      this.upgrade({ receipt_language: this.setting.receipt_language });
    },
    change_score_alias_name() {
      this.upgrade({ score_alias_name: this.setting.score_alias_name });
    },
    change_material_alias_name() {
      this.upgrade({ material_alias_name: this.setting.material_alias_name });
    },
    change_pickup_code_auto_clear() {
      this.upgrade({
        pickup_code_auto_clear: this.setting.pickup_code_auto_clear,
      });
    },
    change_order_pickup_code_digit() {
      this.upgrade({
        order_pickup_code_digit: this.setting.order_pickup_code_digit,
      });
    },
    change_sms_open() {
      this.upgrade({ vip_sms_open: this.setting.vip_sms_open });
    },
    change_pickup_code_show() {
      this.upgrade({ pickup_code_show: this.setting.pickup_code_show });
    },
    change_pickup_code_alias_name() {
      this.upgrade({
        pickup_code_alias_name: this.setting.pickup_code_alias_name,
      });
    },
    change_customer_level_auto_upgrade() {
      this.upgrade({
        customer_level_auto_upgrade: this.setting.customer_level_auto_upgrade,
      });
    },
    change_enable_tax() {
      this.upgrade({
        enable_tax: this.setting.enable_tax,
      });
    },
    change_enable_i18n() {
      this.upgrade({
        enable_i18n: this.setting.enable_i18n,
      });
    },
    change_customer_level_upgrade_method() {
      this.upgrade({
        customer_level_upgrade_method:
          this.setting.customer_level_upgrade_method,
      });
    },
    change_open_wechat_facepay() {
      this.upgrade({ open_wechat_facepay: this.setting.open_wechat_facepay });
    },
    change_open_alipay_facepay() {
      this.upgrade({ open_alipay_facepay: this.setting.open_alipay_facepay });
    },
    change_show_mp() {
      this.upgrade({ show_mp: this.setting.show_mp });
    },
    change_first_order_discount() {
      this.upgrade({ first_order_discount: this.setting.first_order_discount });
    },
    change_first_order_discount_open() {
      this.upgrade({
        first_order_discount_open: this.setting.first_order_discount_open,
      });
    },
    change_zero_stock_sale() {
      this.upgrade({ zero_stock_sale: this.setting.zero_stock_sale });
    },
    change_customer_score_open() {
      this.upgrade({ customer_score_open: this.setting.customer_score_open });
    },
    change_score_gain_rate() {
      const rate = Math.round(this.setting.score_gain_rate * 100) / 100;
      this.setting.score_gain_rate = rate;
      this.upgrade({ score_gain_rate: rate });
    },
    change_customer_score_rate() {
      const rate = Math.round(this.setting.customer_score_rate * 100) / 100;
      this.setting.customer_score_rate = rate;
      this.upgrade({ customer_score_rate: rate });
    },
    async change_discount_order() {
      await this.upgrade({ discount_order: this.setting.discount_order });
      this.display();
    },
    async saveSecondCardRate() {
      await this.upgrade({
        second_card_rate: parseFloat(this.setting.second_card_rate),
      });
    },
    async savePackageId() {
      await this.upgrade({ package_id: parseFloat(this.setting.package_id) });
    },
    async saveBarcodeId() {
      await this.upgrade({ bar_code_id: parseFloat(this.setting.bar_code_id) });
    },
    async saveWarmTips() {
      await this.upgrade({ warm_tips: this.setting.warm_tips });
    },
    async saveShopCode() {
      await this.upgrade({ shop_code: this.setting.shop_code });
    },
    async saveAlipayMerchantNo() {
      await this.upgrade({
        alipay_merchant_no: this.setting.alipay_merchant_no,
      });
    },
    async saveSecondCardName() {
      await this.upgrade({ second_card_name: this.setting.second_card_name });
    },
    async saveVirtualWeight() {
      await this.upgrade({
        show_virtual_weight: this.setting.show_virtual_weight,
      });
    },
    getDiscountRowOrder(order) {
      return order;
    },
    async changeDuration(value) {
      await this.upgrade({ wechat_operate_duration: value });
    },
    async change_fixed_freight(value) {
      await this.upgrade({ fixed_freight: value });
    },
    async change_auto_receive(value) {
      await this.upgrade({ auto_receive: value });
    },
    async change_receive_duration_day() {
      await this.upgrade({
        receive_duration_day: this.setting.receive_duration_day,
      });
    },
    async change_login_window_alert(value) {
      await this.upgrade({ login_window_alert: value });
    },
    async change_auto_close_estimation(value) {
      await this.upgrade({ auto_close_estimation: value });
    },
    async change_is_frontent_attend_rebate(value) {
      await this.upgrade({ is_frontent_attend_rebate: value });
    },
    async change_tax_rate() {
      await this.upgrade({ tax_rate: this.setting.tax_rate });
    },
    async change_service_charge_rate() {
      await this.upgrade({
        service_charge_rate: this.setting.service_charge_rate,
      });
    },
    change_timezone() {
      this.upgrade({ timezone: this.setting.timezone });
    },
    change_currency() {
      this.upgrade({ currency: this.setting.currency });
    },
    renderDiscountItem(order) {
      const orderText = {
        huiyuanjia: i18n.t("pages_ai_thirdparty_167"),
        special_price: i18n.t("pages_birthday_discount_index_211"),
      }[order];
      return orderText || order;
    },
    async change_open_score_shop(value) {
      await this.upgrade({ open_score_shop: value });
    },
    async change_pay_method_button_display(value) {
      await this.upgrade({ pay_method_button_display: value });
    },
    async change_show_language_button(value) {
      await this.upgrade({ show_language_button: value });
    },
  },
};
</script>
